var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchdev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20001 32.4002L11.7847 27.8155M11.7847 27.8155C12.5688 28.5996 13.4997 29.2216 14.5241 29.6459C15.5486 30.0703 16.6466 30.2887 17.7555 30.2887C18.8643 30.2887 19.9623 30.0703 20.9868 29.6459C22.0113 29.2216 22.9421 28.5996 23.7262 27.8155C24.5103 27.0314 25.1323 26.1006 25.5566 25.0761C25.981 24.0517 26.1994 22.9537 26.1994 21.8448C26.1994 20.7359 25.981 19.6379 25.5566 18.6134C25.1323 17.589 24.5103 16.6581 23.7262 15.874C22.1427 14.2905 19.9949 13.4009 17.7555 13.4009C15.516 13.4009 13.3683 14.2905 11.7847 15.874C10.2012 17.4576 9.31155 19.6053 9.31155 21.8448C9.31155 24.0843 10.2012 26.232 11.7847 27.8155Z",
    stroke: "#FF9515",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 23.2572C2.15188 21.1069 1.49627 18.6641 1.50002 16.1778C1.50002 8.3479 7.88021 2 15.75 2H25.25C33.1198 2 39.5 8.3479 39.5 16.1778C39.5 22.3528 35.5347 27.6044 30 29.55",
    stroke: "#FF9515",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchdev);
export default __webpack_public_path__ + "static/media/searchdev.4d1b1d7b81460b9888502f479023dd2a.svg";
export { ForwardRef as ReactComponent };